import * as React from "react";
import {translate} from "react-i18next";
import {RouteComponentProps} from "react-router-dom";
import {ICommonViewProps} from "./ViewContainer";

// semantic
import {Message} from "semantic-ui-react";

interface IAccessDeniedViewParams extends ICommonViewProps, RouteComponentProps<any> {
    missingLinks: string[];
}

class AccessDeniedView extends React.Component<IAccessDeniedViewParams> {
    render() {
        const {t, missingLinks} = this.props;
        const translatedLinks = missingLinks.map(str => t(str));
        return (
            <div>
                <Message
                    negative={true}
                    style={{
                        margin: "5px",
                        width: "initial",
                        position: "initial"
                    }}
                >
                    <Message.Header>{t("MISSING_ACCESS_RIGHTS")}</Message.Header>
                        <Message>
                            {"Missing links: " + translatedLinks.join(", ")}
                        </Message>
                </Message>
            </div>
        );
    }
}

export default translate("LOGIN")(AccessDeniedView);



// WEBPACK FOOTER //
// ./src/views/AccessDeniedView.tsx